module.exports = __webpack_public_path__ + "static/clutch-2056af8e9fe271b432cd7c8c9095f16b.png";